import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Zap } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const BG =
  "https://images.unsplash.com/photo-1782787543356-84e69567ccd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxydW5uaW5nJTIwY291cGxlJTIwc3Vuc2V0JTIwb3V0ZG9vcnN8ZW58MHx8fHwxNzg1MTQ1OTc5fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success(`Willkommen zurück, ${data.user.name}!`);
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex flex-col justify-end bg-[#0A0A0A]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/40" />

      <div className="relative z-10 px-6 pt-20 pb-10 max-w-lg w-full mx-auto">
        <div className="flex items-center gap-2 mb-2">
          <Zap className="w-7 h-7 text-[#CCFF00]" fill="#CCFF00" />
          <span className="font-display font-black text-2xl tracking-tighter">PACELINE</span>
        </div>
        <h1 className="font-display font-black text-5xl tracking-tighter leading-none mb-8">
          Willkommen<br />zurück.
        </h1>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="data-label block mb-2">E-Mail</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#121212] border border-white/10 rounded-2xl px-4 py-4 text-white placeholder-neutral-600 focus:border-[#CCFF00] focus:outline-none transition-colors"
              placeholder="du@beispiel.de"
            />
          </div>
          <div>
            <label className="data-label block mb-2">Passwort</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#121212] border border-white/10 rounded-2xl px-4 py-4 text-white placeholder-neutral-600 focus:border-[#CCFF00] focus:outline-none transition-colors"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#CCFF00] text-black font-display font-black text-lg rounded-full py-4 active:scale-95 transition-transform disabled:opacity-60"
          >
            {loading ? "Anmelden..." : "Einloggen"}
          </button>
        </form>

        <p className="text-center text-neutral-400 mt-6 text-sm">
          Noch kein Konto?{" "}
          <Link to="/register" data-testid="go-register" className="text-[#CCFF00] font-bold">
            Registrieren
          </Link>
        </p>
      </div>
    </div>
  );
}
